<template>
  <div
    :class="{ 'scrollable-container' : isMobile }"
    class="page-home"
  >
    <section class="section section-centered">
      <div class="container">
        <div class="row row-grid justify-content-center">
          <div class="text-center">
            <img
              v-if="client.logo"
              :src="client.logo"
              class="logo-client"
              alt="logotipo"
            >
            <div v-if="verifyStart">
              <h2 class="display-3">{{ title }}</h2>
              <p
                v-if="description"
                class="lead"
              >{{ description }}</p>
            </div>
            <b-message
              v-if="!verifyStart && alert.show"
              type="is-danger"
            >
              {{ alert.message }}
            </b-message>
            <button
              v-if="!verifyStart && canRetryInit"
              :disabled="initializing"
              @click="validInit"
              type="button"
              class="btn btn-primary mb-3 mb-sm-0"
            >Tentar novamente</button>
            <div
              v-if="verifyStart"
              class="btn-wrapper"
            >
              <base-alert
                v-if="alert.show"
                :type="alert.type"
                icon="fa fa-exclamation-circle"
                dismissible
              >
                <span slot="text">{{ alert.message }}</span>
              </base-alert>
              <form
                id="init-validation-form"
                ref="element"
                @submit="validData"
                class="form-alignment"
              >
                <base-input
                  v-if="verifyStart && showCPFInput"
                  v-model="form.document"
                  v-mask="'###.###.###-##'"
                  :valid="documentValidState"
                  :masked="false"
                  :error="documentErrorMessage"
                  type="tel"
                  placeholder="000.000.000-00"
                  label="CPF"
                  title="CPF"
                  class="input-cpf"
                />
                <div
                  :class="{ 'has-checkbox-error': $v.form.terms.$error }"
                  class="checkbox-wrapper mb-3"
                >
                  <base-checkbox
                    v-model="form.terms"
                  >
                    <span>{{ client['text-privacy-policy'] || 'Eu concordo com a' }}
                      <a
                        :href="client.terms"
                        target="_blanck"
                      >{{ client['text-privacy-policy-link'] || 'política de privacidade' }}</a>
                    </span>
                  </base-checkbox>
                </div>
                <button
                  v-if="verifyStart"
                  :disabled="loading"
                  type="submit"
                  class="btn btn-primary mb-3 mb-sm-0"
                >{{ textInit }}</button>
              </form>
            </div>
          </div>
        </div>
      </div>
      <span class="tag-version">
        V {{ version }}
      </span>
    </section>
    <modal
      v-model="form.document"
      :show.sync="notification.show"
      :gradient="notification.type"
      :show-close="false"
      :close-backdrop="false"
      modal-classes="modal-danger modal-dialog-centered"
    >
      <div class="py-3 text-center">
        <img
          v-lazy="'img/icons/common/error.png'"
        >
        <h6
          v-if="notification.title"
          class="title-default m-4"
        >{{ notification.title }}</h6>
        <p class="mt-4">
          {{ notification.message }}
        </p>
      </div>
    </modal>
  </div>
</template>
<script>
// import {
//   checkDeviceIsMobile
// } from '@/utils/validate'
import Modal from '@/components/Modal.vue'
import { required } from 'vuelidate/lib/validators'
import { validateCPF } from '@/utils/validate'
import { mapActions, mapGetters } from 'vuex'
import version from '@/version'
import {
  setLayoutPortal,
  removeSpecialCharacters
} from '@/utils'
import IncogniaWebSdk from '@incognia/web-sdk'
import { getUserData, getAccessData } from '@/auth'
import { reportSessionFailure } from '@/helpers/session-failure'

const validCPF = (value) => validateCPF(value)
const acceptedTerms = (value) => value === true
const booleanIsTrue = (value) => value === true || value === 'true' || value === 1 || value === '1'
const hasOwn = (object, property) => Object.prototype.hasOwnProperty.call(object, property)

export default {
  name: 'HomeView',
  components: {
    Modal
  },
  data() {
    return {
      loading: false,
      initializing: false,
      canRetryInit: false,
      expectedUserCode: '',
      keyValid: null,
      title: 'Seja bem-vindo(a)',
      description: 'Confirme o seu CPF, para darmos seguimento a sua validação:',
      textInit: 'Iniciar validação',
      verifyStart: false,
      version: version,
      showCPFInput: true,
      alert: {
        show: false,
        type: 'danger',
        message: ''
      },
      notification: {
        show: false,
        type: 'danger',
        showAction: false,
        title: '',
        message: ''
      },
      form: {
        document: '',
        terms: false
      },
      deviceToken: ''
    }
  },
  computed: {
    ...mapGetters({
      client: 'client',
      device: 'device'
    }),
    isMobile() {
      return this.device === 'mobile'
    },
    isDesktop() {
      return this.device === 'desktop'
    },
    documentValidState() {
      if (!this.showCPFInput || !this.$v?.form?.document) {
        return null
      }

      if (!this.$v.form.document.$dirty) {
        return null
      }

      return !this.$v.form.document.$invalid
    },
    documentErrorMessage() {
      if (!this.showCPFInput || !this.$v?.form?.document) {
        return ''
      }

      return this.$v.form.document.$dirty && this.$v.form.document.$invalid
        ? 'CPF inválido, verifique e tente novamente'
        : ''
    }
  },
  created() {
    this.keyValid = this.$route.query.y

    // if (!checkDeviceIsMobile()) {
    //   this.notification.show = true
    //   this.notification.title = 'Dispositivo não permitido'
    //   this.notification.message = 'Por favor, para prosseguir acesso pelo seu celular!'
    //   return
    // }

    if (!this.keyValid) {
      this.notification.show = true
      this.notification.title = 'Cliente não identificado'
      this.notification.message = 'Não conseguimos identificar o cliente com base nas informações fornecidas. Por favor, verifique o endereço do portal e tente novamente.'
      return
    }

    this.validInit()
  },
  validations() {
    return {
      form: {
        document: this.showCPFInput ? { required, validCPF } : {},
        terms: { acceptedTerms }
      }
    }
  },
  methods: {
    ...mapActions([
      'setClient',
      'validInitTransaction',
      'startFlowTransaction',
      'saveDataUser',
      'setFlowTransaction',
      'setRiskDevice',
      'setRiskDeviceId'
    ]),
    clearQuery() {
      const novaURL = window.location.protocol + '//' + window.location.host + window.location.pathname
      window.history.replaceState({}, document.title, novaURL)
    },
    getErrorMessage(error, fallback) {
      const messageKey = error?.response?.data?.message || error?.data?.message
      if (!messageKey) return fallback

      const translatedMessage = this.$t(`errors.${messageKey}`)
      return translatedMessage.includes('errors.') ? fallback : translatedMessage
    },
    async validInit() {
      if (this.initializing || this.loading) {
        return
      }

      this.initializing = true
      this.canRetryInit = false
      this.expectedUserCode = ''
      try {
        const data = await this.validInitTransaction({ code: this.keyValid })
        if (data.success) {
          const { data: dataValid } = data.data

          this.setClient(dataValid)
          setLayoutPortal(dataValid)

          if (booleanIsTrue(dataValid['block-desktop']) && this.isDesktop) {
            this.notification.show = true
            this.notification.title = 'Dispositivo não permitido'
            this.notification.message = 'Por favor, acesse pelo seu celular para prosseguir com a validação.'
            return
          }

          if (dataValid['risk-device']) {
            this.setRiskDevice(dataValid['risk-device'])
            this.setRiskDeviceId(dataValid['risk-device-id'])
            await IncogniaWebSdk.init({ appId: dataValid['risk-device-id'] })
            this.deviceToken = await IncogniaWebSdk.generateRequestToken()
          }

          const textInitialDescription = hasOwn(dataValid, 'text-initial-description')
            ? dataValid['text-initial-description']
            : dataValid.textInitialDescription
          if (hasOwn(dataValid, 'text-initial-description') || hasOwn(dataValid, 'textInitialDescription')) {
            this.description = textInitialDescription
          }
          if (dataValid['text-initial-title']) {
            this.title = dataValid['text-initial-title']
          }
          if (dataValid['text-initial-buttom']) {
            this.textInit = dataValid['text-initial-buttom']
          }
          if (hasOwn(dataValid, 'show-cpf-input')) {
            this.showCPFInput = booleanIsTrue(dataValid['show-cpf-input'])
          }

          const userSaved = await this.saveDataUser({ code: dataValid.code, key: this.keyValid })
          if (!userSaved || await getUserData() !== dataValid.code || await getAccessData() !== this.keyValid) {
            reportSessionFailure('initialize', 'cookie_verification_failed')
            this.verifyStart = false
            this.canRetryInit = true
            this.alert = {
              show: true,
              type: 'danger',
              message: 'Não foi possível salvar os dados desta sessão no navegador. Tente novamente.'
            }
            return
          }

          this.alert.show = false
          this.expectedUserCode = dataValid.code
          this.verifyStart = true
        } else {
          reportSessionFailure('initialize', 'request_failed')
          this.verifyStart = false
          this.canRetryInit = true
          this.alert = {
            show: true,
            type: 'danger',
            message: this.getErrorMessage(data.error, this.$t('messages.not_start'))
          }
        }
      } catch (error) {
        reportSessionFailure('initialize', 'unexpected_error')
        this.verifyStart = false
        this.canRetryInit = true
        this.alert = {
          show: true,
          type: 'danger',
          message: this.$t('messages.not_start')
        }
      } finally {
        this.initializing = false
      }
    },
    validData(e) {
      e.preventDefault()
      this.$v.form.$touch()

      if (this.$v.form.$invalid) {
        return this.$buefy.toast.open({
          duration: 5000,
          message: `Por favor, verifique os campos <b>obrigatórios</b>!`,
          position: 'is-top',
          type: 'is-danger'
        })
      }
      this.validTransactionStart()
    },
    async validTransactionStart() {
      if (this.loading || this.initializing || !this.verifyStart) {
        return
      }

      this.loading = true
      try {
        const userCode = await getUserData()
        const accessCode = await getAccessData()
        if (!this.expectedUserCode || userCode !== this.expectedUserCode || accessCode !== this.keyValid) {
          reportSessionFailure('start_flow', 'cookie_verification_failed')
          this.verifyStart = false
          this.expectedUserCode = ''
          this.canRetryInit = true
          this.alert = {
            show: true,
            type: 'danger',
            message: 'Os dados desta sessão não estão disponíveis. Tente novamente para reiniciar a validação.'
          }
          return
        }

        const data = await this.startFlowTransaction({
          document: removeSpecialCharacters(this.form.document),
          deviceToken: this.deviceToken
        })

        if (data.success) {
          const { data: dataValid } = data.data
          this.setFlowTransaction(dataValid.flow)

          const nextStep = dataValid.nextStep
          if (nextStep) {
            this.$router.push({
              name: nextStep
            })
          }
        } else {
          if (data.error && data.error.sessionPersistenceFailed) {
            this.verifyStart = false
            this.expectedUserCode = ''
            this.canRetryInit = true
          } else {
            reportSessionFailure('start_flow', 'request_failed')
          }
          this.alert = {
            show: true,
            type: 'danger',
            message: this.getErrorMessage(data.error, 'Não foi possível validar sua solicitação')
          }
        }
      } catch (error) {
        reportSessionFailure('start_flow', 'unexpected_error')
        this.alert = {
          show: true,
          type: 'danger',
          message: 'Não foi possível validar sua solicitação'
        }
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
<style lang="scss">
.scrollable-container {
  overflow-y: auto;
  max-height: 100vh;
}
.page-home {
  .form-alignment {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    max-width: 620px;
    .checkbox-wrapper {
      width: 100%;
    }
    .checkbox-error {
      display: block;
      text-align: left;
    }
    .has-checkbox-error {
      .custom-control-label::before {
        border-color: #f5365c;
      }
      .custom-control-label,
      .custom-control-label span,
      .custom-control-label a {
        color: #f5365c !important;
      }
    }
    .custom-control-label {
      span {
        top: 0px;
      }
    }
  }
  .lead {
    margin-bottom: 10px;
  }
  .input-cpf {
    width: 100%;
    text-align: left;
    font-weight: 500;
    font-size: 0.875rem;
    input {
      background-color: var(--background-input)!important;
      color: var(--text-input-color)!important;
      text-align: left;
    }
    input::placeholder {
      color: var(--text-input-color)!important;
    }
    &:after {
      top: 32px;
    }
  }
  @media (min-width: 768px) {
    .input-cpf {
      width: 250px;
    }
    .scrollable-container {
      max-height: 100vh;
    }
  }
}
</style>
